// extracted by mini-css-extract-plugin
export default {"moreList":"index_moreList_9dh2W","ulList":"index_ulList_W2fc9"};